// Angular
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

// Libraries
import { Moment } from 'moment';
import * as moment from 'moment';

// Models
import { BankData, CardData } from 'src/app/modules/payments/models/payments';
import { UserDebit } from 'src/app/modules/account/models/user';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { PaymentsService } from 'src/app/modules/payments/payments.service';
import { UserService } from 'src/app/modules/account/user.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';

// Definitions
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-procedures-debit',
  templateUrl: './procedures-debit.component.html',
  styleUrls: ['./procedures-debit.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [ MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS ]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ProceduresDebitComponent implements OnInit {
  public isDebitSet: boolean;
  public isDebitType: string;
  public banks: BankData [];
  public cards: CardData [];
  public formData: FormGroup = new FormGroup({
    type: new FormControl('', [Validators.required]),
    cbu: new FormControl('', [Validators.required]),
    cardNumber: new FormControl('', [Validators.required]),
    cardEntity: new FormControl('', [Validators.required]),
    cardDateExpiration: new FormControl(moment(), [Validators.required]),
    holder: new FormControl('', [Validators.required]),
    dni: new FormControl('', [Validators.required]),
    bank: new FormControl('', [Validators.required]),
  });

  constructor(
    public dialog: MatDialogRef<ProceduresDebitComponent>,
    private uiDialog: MatDialog,
    private uiService: UiService,
    private userService: UserService,
    private platformService: PlatformService,
    private paymentsService: PaymentsService,
    private proceduresService: ProceduresService,
  ) {
    this.valitatorsSet();

    this.isDebitSet = this.userService.currentUser.value.debitIsSet();
    this.isDebitType = this.userService.currentUser.value.debitGetType();
  }

  ngOnInit(): void {
    if (!this.isDebitSet) {
      this.onInitGet();
    }
  }

  onInitGet(): void{
    this.uiService.showSpinner(true);

    const apiCalls = [
      this.paymentsService.banksGet(),
      this.paymentsService.cardsGet(),
    ];

    if (this.isDebitType !== '') {
      apiCalls.push(this.paymentsService.debitGet(this.isDebitType));
    }

    Promise.all(apiCalls).then((results) => {
      this.uiService.showSpinner(false);
      this.banks = results[0].result;
      this.cards = results[1].result;

      /*if(this.isDebitType == 'cbu'){
        this.formData.setValue({
          'type': this.isDebitType,
          'holder': results[2].result.holder,
          'dni': results[2].result.dni,
          'bank': results[2].result.bank.id,
          'cbu': results[2].result.cbu,
        })
      } else if (this.isDebitType == 'credit') {
        this.formData.setValue({
          'type': this.isDebitType,
          'holder': results[2].result.holder,
          'dni': results[2].result.dni,
          'bank': results[2].result.bank.id,
          'cardNumber': results[2].result.number,
          'cardEntity' : results[2].result,
          'cardDateExpiration': results[2].result,
        })
      }*/
    }).catch(reason => {
      this.uiService.showSpinner(false);
      this.dialog.close();
      this.uiService.dialogShow('Ups!', 'No es posible adherir el débito automático en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  onUpdate(): void{
    this.isDebitSet = false;

    this.onInitGet();
  }

  onCancel(): void {
    this.dialog.close();
  }

  onRemove(): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '350px',
      data: {
          title: 'Anular débito',
          message: '¿Estas seguro de cancelar el débito automático de tu cuenta?',
          buttonConfirmText: 'Anular',
          action: () => {
            this.uiService.showSpinner(true);

            this.paymentsService.debitRemove().then((result) => {
              if (result.status) {
                this.dialog.close();

                this.uiService.showSpinner(false);
                this.uiService.dialogShow('Débito anulado', 'El débito automático se anuló correctamente.', 'success');

                this.userService.updateData('debit', new UserDebit(''));
              }
              else {
                this.uiService.showSpinner(false);
                this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar anular el débito automático. Por favor intenta nuevamente.', 'error');
              }
            }, (error) => {
              this.uiService.showSpinner(false);
              this.uiService.dialogShow('Ups!', 'No es posible anular el débito automático en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
            });
          }
      }
    });
  }

  onSend(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.paymentsService.debitAdd(
        this.formData.get('type')?.value,
        this.formData.get('holder')?.value,
        this.formData.get('dni')?.value,
        this.bankGet(this.formData.get('bank')?.value),
        this.formData.get('cbu')?.value,
        this.formData.get('cardNumber')?.value,
        this.cardGet(this.formData.get('cardEntity')?.value),
        moment(this.formData.get('cardDateExpiration')?.value).format('YYYY-MM-DD'),
      ).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Débito automático adherido', 'El débito automático se añadio correctamente.', 'success');

          this.proceduresService.proceduresUpdate(true);
          this.userService.updateData('debit', new UserDebit(this.formData.get('type')?.value));
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar adherir el débito automático. Por favor intenta nuevamente.', 'error');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible adherir el débito automático en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  private bankGet(id: number): BankData{
    let bank = new BankData();

    this.banks.forEach((value: any, index: number) => {
      if (value.id === id){
        bank = value;
      }
    });

    return bank;
  }

  private cardGet(id: number): CardData{
    let card = new CardData();

    this.cards.forEach((value: any, index: number) => {
      if (value.id === id) {
        card = value;
      }
    });

    return card;
  }

  public chosenYearHandler(normalizedYear: Moment): void {
    const control = this.formData.get('cardDateExpiration');

    if (control) {
      const ctrlValue = control.value;
      ctrlValue.year(normalizedYear.year());
      control.setValue(ctrlValue);
    }
  }

  public chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const control = this.formData.get('cardDateExpiration');

    if (control) {
      const ctrlValue = control.value;
      ctrlValue.month(normalizedMonth.month());
      control.setValue(ctrlValue);
      datepicker.close();
    }
  }

  public formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      type: {
        required:  'Seleccione el tipo de débito'
      },
      cbu: {
        required:  'Ingrese un número de CBU',
        invalid:  'El número de CBU es inválido'
      },
      cardNumber: {
        required:  'Ingrese un número de tarjeta',
        invalid:  'El número de tarjeta es invalido',
      },
      cardEntity: {
        required:  'Seleccione el nombre de la tarjeta'
      },
      cardDateExpiration: {
        required:  'Ingrese la fecha de vencimiento de la tarjeta'
      },
      holder: {
        required:  'Ingrese el nombre y apellido del titular'
      },
      dni: {
        required:  'Ingrese el DNI del titular',
        invalid:  'El DNI ingresado es inválido'
      },
      bank: {
        required:  'Seleccione el banco al que pertenese la tarjeta'
      },
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }

  private valitatorsSet(): void {
    this.formData.get('type')?.valueChanges.subscribe((value) => {
      if (value === 'cbu') {
        this.formData.get('cbu')?.setValidators([
          Validators.required,
          this.validateCBU()
        ]);
        this.formData.get('cardNumber')?.clearValidators();
        this.formData.get('cardEntity')?.clearValidators();
        this.formData.get('cardDateExpiration')?.clearValidators();
      }  else if (value === 'credit'){
        this.formData.get('cbu')?.clearValidators();
        this.formData.get('cardNumber')?.setValidators([
          Validators.required,
          this.validateCard()
        ]);
        this.formData.get('cardEntity')?.setValidators(Validators.required);
        this.formData.get('cardDateExpiration')?.setValidators(Validators.required);
      } else {
        this.formData.get('cbu')?.clearValidators();
        this.formData.get('cardNumber')?.clearValidators();
        this.formData.get('cardEntity')?.clearValidators();
        this.formData.get('cardDateExpiration')?.clearValidators();
      }

      this.formData.get('cbu')?.updateValueAndValidity();
      this.formData.get('cardNumber')?.updateValueAndValidity();
      this.formData.get('cardEntity')?.updateValueAndValidity();
      this.formData.get('cardDateExpiration')?.updateValueAndValidity();
    });

    this.formData.get('dni')?.setValidators([
      Validators.required,
      this.validateDNI()
    ]);

    this.formData.get('dni')?.updateValueAndValidity();
  }

  private validateCard(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = this.platformService.validarNumeroTarjeta(String(control.value));
      let validationResult: ValidationErrors | null = isValid ? null : { invalid: true };

      if (typeof validationResult === 'undefined' || control.value == '') {
        validationResult = null;
      }

      return validationResult;
    };
  }

  private validateCBU(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = this.platformService.validarCBU(String(control.value));
      let validationResult: ValidationErrors | null = (isValid === true) ? null : { invalid: true };

      if (typeof validationResult === 'undefined' || control.value == '') {
        validationResult = null;
      }

      return validationResult;
    };
  }

  private validateDNI(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = this.platformService.validarCUIT(String(control.value));
      let validationResult: ValidationErrors | null = (isValid === true) ? null : { invalid: true };

      if (typeof validationResult === 'undefined' || control.value == '') {
        validationResult = null;
      }

      return validationResult;
    };
  }
}
